import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { createSearchParams } from '../utils';

const sessionListActiveApi = new Api('orientations/active');
const groupSessionListActiveApi = new Api('orientations/:id/sessions/active');

function* loadSessionsActive(data) {
  try {
    const { page = 1, pageSize = 10, column, order, filter } = data.payload;
    const defaultSearchParams = { page, per_page: pageSize, column, order };
    const searchParams = createSearchParams({
      defaultSearchParams,
      filter,
      tab: 'active',
    });

    const result = yield call(
      sendRequest,
      sessionListActiveApi.load,
      { search: searchParams },
      notifications.REQUEST_ERROR,
    );

    if (result.data.success) {
      const {
        data: {
          success: { data: sessions },
        },
      } = result;
      yield put(actions.loadSessionsActiveSuccess(sessions));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadGroupSessionsActive(data) {
  try {
    const { page = 1, pageSize = 10, column, order, filter, recurrenceSessionId } = data.payload;
    const defaultSearchParams = { page, per_page: pageSize, column, order };
    const searchParams = createSearchParams({
      defaultSearchParams,
      filter,
      tab: 'past',
    });

    const result = yield call(
      sendRequest,
      groupSessionListActiveApi.load,
      { id: recurrenceSessionId, search: searchParams },
      notifications.REQUEST_ERROR,
    );

    if (result.data.success) {
      const {
        data: {
          success: { data: sessions },
        },
      } = result;
      yield put(actions.loadGroupSessionsActiveSuccess(sessions));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadSessionsActive)]);
  yield all([takeEvery(actions.LOAD_GROUP_REQUEST, loadGroupSessionsActive)]);
}
